// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IAvailableJksSchema } from './AvailableJksSchema';
import type { IBankSchema } from './BankSchema';
import type { IFeatureSchema } from './FeatureSchema';
import type { IMortgageParamsSchema } from './MortgageParamsSchema';

export interface IPromoInfoSchema {
  /** Логотип застройщика/агента **/
  authorLogoUrl?: string;
  /** Название (имя) застройщика/агента **/
  authorName?: string;
  /** Realty user id, разместившего акцию **/
  authorRealtyUserId?: number;
  /** Список ЖК в которых доступна акция **/
  availableJks?: IAvailableJksSchema[];
  /** Банк - автор **/
  bank?: IBankSchema;
  /** Список Банков **/
  banks?: IBankSchema[];
  /** ID компании, разместившей акцию **/
  companyId?: number;
  /** Описание акции **/
  description?: string;
  /** Срок действия акции **/
  end?: string;
  /** Особенности акции **/
  features?: IFeatureSchema[];
  /** Акция Черной Пятницы **/
  isBlackFriday?: boolean;
  /** Эксклюзивная акция на ЦИАН **/
  isExclusive?: boolean;
  /** Акция от банка **/
  isFromBank?: boolean;
  /** Акция от застройщика **/
  isFromBuilder?: boolean;
  /** Параметры акции по ипотеке **/
  mortgageParams?: IMortgageParamsSchema;
  /** Название акции **/
  name: string;
  /** ID Акции. Deprecated (используй unique_promo_id) **/
  promoId: number;
  /** Изображение для акции **/
  promoImage?: string;
  /** Источник акции (застройщик/представитель) **/
  promoSource?: string;
  /** Тип акции **/
  promoType: EPromoType;
  /** Дата начала действия акции **/
  start?: string;
  /** Подзаголовок акции **/
  subtitle?: string;
  /** ID Акции **/
  uniquePromoId: string;
}
export enum EPromoType {
  /** Акция от банка **/
  'Bank' = 'bank',
  /** Бонусы **/
  'Bonus' = 'bonus',
  /** Циан ипотека **/
  'CianMortgage' = 'cianMortgage',
  /** Скидки **/
  'Discount' = 'discount',
  /** Материнский капитал **/
  'MaternalCapital' = 'maternalCapital',
  /** Военная ипотека **/
  'MilitaryMortgage' = 'militaryMortgage',
  /** Ипотека **/
  'Mortgage' = 'mortgage',
}
